// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"buttongroup_wrapper__3YnkJ"};